import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, DialogTitle, Typography } from '@mui/material';
import { useBusinessPlanOptions } from 'constants/businessPlan';
import { v4 as uuidV4 } from 'uuid';

import { Modal } from 'components/_basic/Modal';
import { CreateProjectButton } from 'components/CreateProjectButton';

import { ICreateProjectModalProps } from './types';

import styles from './CreateProjectModal.module.scss';

export const CreateProjectModal: React.FC<ICreateProjectModalProps> = ({ close }) => {
  const { t } = useTranslation();
  const businessPlanOptions = useBusinessPlanOptions();
  return (
    <Modal maxWidth="xs" className={styles.modal} close={close}>
      <Box className={styles.content}>
        <DialogTitle>{t('createProject')}</DialogTitle>
        <Typography variant="subtitle2" sx={{ marginBottom: 1 }}>
          {t('selectDocType')}
        </Typography>

        {businessPlanOptions.map((option) => (
          <CreateProjectButton key={uuidV4()} {...option} />
        ))}
      </Box>
    </Modal>
  );
};
